import { Engineering, Person, Receipt } from '@mui/icons-material';
import {
  Box,
  Button,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  Typography,
} from '@mui/material';
import { GETBookingById } from '../../../services/booking';
import { useEffect, useState } from 'react';
import { IBooking } from '../../../utils/entities/interface';
import { Link, useParams } from 'react-router-dom';
import {
  capitalizeWords,
  formatDate,
  formatPhoneNumber,
} from '../../../utils/helper';
import { getBookingStatusLabel, Invoice } from './Assignbooking';
import { AddOrderItems } from '../../../components/common/AddOrderItem';
import { ViewBookedServices } from '../../../components/organisms/bsesrvices';
import { CustomerBookingDetails } from '../../../components/organisms/cbdetails';
import { ACServiceDetails } from '../../../components/organisms/acServiceReport';
import { DetailPageHeader } from '../../../components/layout/DetailPageHeader';
import {
  canManageBookingInvoice,
  getInvoiceActionLabel,
  hasBookingInvoice,
} from '../../../utils/bookingInvoice';
interface OtherService {
  service: string;
  problem: string;
  comments: string;
  acType?: string;
}

interface AcList {
  services: string[];
  acList: Record<string, number | string>;
}

interface CopperPiping {
  comments: string;
  quantity: string;
  place: string;
}

interface ViewBookingProps {
  type?: 'REGULAR' | 'CUSTOMERHISTORY' | 'TECHNICIANHISTORY' | 'VIEWDETAIL';
}
export const ViewBooking = ({ type }: ViewBookingProps) => {
  const { bookingId } = useParams<{ bookingId: string }>();
  const [booking, setBooking] = useState<IBooking | null>(null);
  const [selectedSlot, setSelectedSlot] = useState<
    'FIRST_HALF' | 'SECOND_HALF'
  >('FIRST_HALF');
  const [basicService, setBasicService] =
    useState<Record<string, Record<string, number>>>();

  const [otherService, setOtherServices] = useState<OtherService | null>(null);
  const [copperpipingService, setCopperPipingService] =
    useState<CopperPiping | null>(null);
  const [amcservice, setAmcService] = useState<CopperPiping | null>(null);
  const [commercialAcService, setCommercialAcService] = useState<AcList | null>(
    null,
  );
  const [invoiceModalOpen, setInvoiceModalOpen] = useState(false);

  useEffect(() => {
    if (bookingId) fetchBookingDetails(bookingId);
  }, [bookingId]);

  const fetchBookingDetails = async (id: string) => {
    try {
      const { data } = await GETBookingById(id);

      const serviceAggregation: Record<string, Record<string, number>> = {};

      if (Array.isArray(data.serviceDetails)) {
        if (Array.isArray(data.serviceDetails)) {
          for (const details of data.serviceDetails) {
            if (
              !details ||
              !details.service_data ||
              details.service_data.key === undefined
            ) {
              // Optionally log the invalid row for debugging:
              console.warn(
                'serviceDetails row missing service_data or key:',
                details,
              );
              continue; // Skip bad entries!
            }
            const key = details.service_data.key;

            // Skip saving if the service key matches any in the restricted list

            if (key == 'OTHER') {
              setOtherServices({
                service: key,
                problem: details.otherService,
                comments: details.comment,
                acType: details.acType || '',
              });
            }
            if (key === 'COMMERCIAL_AC') {
              // Filter only 'COMMERCIAL_AC' serviceDetails before reducing
              const filteredCommercialAc = data.serviceDetails.filter(
                (item) => item.service_data.key === 'COMMERCIAL_AC',
              );

              const acList: Record<string, number | string> =
                filteredCommercialAc.reduce(
                  (acc, { acType, quantity }) => {
                    if (/^\d+$/.test(quantity)) {
                      // Only add if previous value is a number, else start from Number(quantity)
                      acc[acType] =
                        typeof acc[acType] === 'number'
                          ? (acc[acType] as number) + Number(quantity)
                          : Number(quantity);
                    } else if (quantity) {
                      acc[acType] = quantity;
                    }
                    return acc;
                  },
                  {} as Record<string, number | string>,
                );

              setCommercialAcService({
                acList,
                services: details.services, // Use current `details` instead of first index
              });
            }

            if (key === 'COPPER_PIPING') {
              setCopperPipingService({
                comments: details.comment,
                quantity: details.quantity,
                place: details.place,
              });
            }
            if (key === 'AMC') {
              setAmcService({
                comments: details.comment,
                quantity: details.quantity,
                place: details.place,
              });
            }
            if (
              ['COMMERCIAL_AC', 'COPPER_PIPING', 'AMC', 'OTHER'].includes(key)
            )
              continue;

            const acType = details.acType
              ? details.acType.toUpperCase()
              : 'UNKNOWN';

            const quantity = parseInt(details.quantity, 10) || 0; // Ensure it's a number

            if (!serviceAggregation[key]) {
              serviceAggregation[key] = {};
            }

            if (!serviceAggregation[key][acType]) {
              serviceAggregation[key][acType] = 0;
            }

            serviceAggregation[key][acType] += quantity;
          }
        }
      }

      setBasicService(serviceAggregation);
      setBooking(data);
      setSelectedSlot(data.slot);
    } catch (error) {
      console.error('Error fetching booking details:', error);
    }
  };

  const reloadBooking = () => {
    if (bookingId) {
      fetchBookingDetails(bookingId);
    }
  };

  const hasInvoice = hasBookingInvoice(booking);
  const canManageInvoice =
    type === 'VIEWDETAIL' &&
    canManageBookingInvoice(booking?.status, hasInvoice);

  console.log(' basicService', basicService);
  console.log(' otherService', otherService);
  console.log(' copperpipingService', copperpipingService);
  console.log(' amcservice', amcservice);
  console.log(' commercialAcService', commercialAcService);
  return (
    <>
      <AddOrderItems
        open={invoiceModalOpen}
        onClose={() => setInvoiceModalOpen(false)}
        orderItems={
          booking && booking.orderItems.length > 0 ? booking.orderItems : []
        }
        booking={booking}
        onReload={reloadBooking}
      />
      <DetailPageHeader
        title={
          type === 'CUSTOMERHISTORY' || type === 'TECHNICIANHISTORY'
            ? 'Booking History'
            : type == 'VIEWDETAIL'
              ? 'View Booking'
              : 'Booking Details'
        }
      />
      <Box
        sx={{
          backgroundColor: '#1C1C1C',
          color: '#fff',
          borderRadius: 2,
          m: 3,
        }}
      >
        {(!type || ['TECHNICIANHISTORY', 'VIEWDETAIL'].includes(type)) && (
          <CustomerBookingDetails
            booking={booking}
            type={
              ['TECHNICIANHISTORY', 'VIEWDETAIL'].includes(type as string)
                ? type
                : undefined
            }
          />
        )}

        {type === 'CUSTOMERHISTORY' && (
          <TechnicianBookingCard booking={booking} />
        )}

        {/* Service Details */}
        <ViewBookedServices
          basicService={basicService || null}
          otherService={otherService || null}
          copperpipingService={copperpipingService || null}
          amcservice={amcservice || null}
          commercialAcService={commercialAcService || null}
        />
        {type == 'CUSTOMERHISTORY' && <Divider sx={{ borderColor: '#444' }} />}
        {type == 'TECHNICIANHISTORY' && (
          <Divider sx={{ borderColor: '#444' }} />
        )}
        {type == 'VIEWDETAIL' && <Divider sx={{ borderColor: '#444' }} />}
        {/* Invoice Setion  */}
        {booking && (hasInvoice || canManageInvoice) && (
          <>
            {' '}
            <Box
              sx={{
                backgroundColor: 'transparent',
                color: '#fff',
                borderRadius: 2,
                paddingBottom: 2,
              }}
            >
              <CardHeader
                title={
                  <Typography variant="h6" sx={{ p: 1 }}>
                    Invoice
                  </Typography>
                }
                action={
                  <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                    {hasInvoice && booking.invoiceUrl ? (
                      <Button
                        size="small"
                        variant="outlined"
                        onClick={() =>
                          window.open(
                            booking.invoiceUrl,
                            '_blank',
                            'noopener,noreferrer',
                          )
                        }
                        sx={{ textTransform: 'none', color: '#fff' }}
                      >
                        View Invoice
                      </Button>
                    ) : null}
                    {canManageInvoice ? (
                      <Button
                        size="small"
                        variant="contained"
                        startIcon={<Receipt />}
                        onClick={() => setInvoiceModalOpen(true)}
                        sx={{
                          textTransform: 'none',
                          backgroundColor: '#407BFF',
                          '&:hover': { backgroundColor: '#3366d6' },
                        }}
                      >
                        {getInvoiceActionLabel(hasInvoice)}
                      </Button>
                    ) : null}
                  </Box>
                }
              />

              {hasInvoice ? (
                <Invoice booking={booking} />
              ) : (
                <Typography sx={{ color: '#8A8D91', px: 2, pb: 2 }}>
                  No invoice created yet. Create an invoice while the booking is
                  in progress.
                </Typography>
              )}
            </Box>{' '}
          </>
        )}
        {type &&
          booking &&
          ['CUSTOMERHISTORY', 'TECHNICIANHISTORY', 'VIEWDETAIL'].includes(
            type,
          ) && <ACServiceDetails booking={booking} onReload={reloadBooking} />}
      </Box>
    </>
  );
};

const TechnicianBookingCard = ({ booking }: { booking: IBooking | null }) => {
  return (
    <>
      {/* Booking Detail Card */}
      <Box
        sx={{
          backgroundColor: 'transparent',
          color: '#fff',
          borderRadius: 2,
        }}
      >
        <CardHeader
          title={
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Typography variant="h6">Technician Detail</Typography>{' '}
                <Engineering />
              </Box>
              <Typography variant="body1">
                Status:{' '}
                <span style={{ color: '#0BE600' }}>
                  {booking?.status && getBookingStatusLabel(booking?.status)}
                </span>
              </Typography>
            </Box>
          }
        />
        <Divider sx={{ borderColor: '#444' }} />
        <CardContent sx={{ backgroundColor: '#232323', p: 3 }}>
          <Grid
            container
            spacing={1}
            sx={{
              display: 'flex',
              justifyContent: 'flex-start',
              //   border: '2px solid red',
            }}
          >
            <Grid item xs={2} sx={{ color: 'gray' }}>
              Technician Name
            </Grid>
            <Grid item xs={4}>
              <Typography
                variant="body1"
                component={booking?.technician?.name ? Link : 'span'}
                {...(booking?.technician?.name && {
                  to: `/technicians/${booking?.technician._id}`,
                })}
                sx={{
                  color: booking?.technician?.name ? '#0BE600' : 'text.primary',
                  textDecoration: booking?.technician?.name
                    ? 'underline'
                    : 'none',
                  cursor: booking?.technician?.name ? 'pointer' : 'default',
                }}
              >
                {booking?.technician?.name || 'Not Assigned'}
              </Typography>
            </Grid>

            <Grid item xs={2} sx={{ color: 'gray' }}>
              Technician Number{' '}
            </Grid>
            <Grid item xs={4}>
              <Typography
                variant="body1"
                sx={{
                  color: '#FFFFFF',
                }}
              >
                {(booking?.technician.phoneNumber &&
                  formatPhoneNumber(booking?.technician.phoneNumber)) ||
                  'Not Available'}
              </Typography>
            </Grid>
            <Grid item xs={2} sx={{ color: 'gray' }}>
              Technician Email
            </Grid>
            <Grid item xs={4}>
              <Typography
                variant="body1"
                sx={{
                  color: '#FFFFFF',
                }}
              >
                {booking?.technician.email || 'Not Available'}
              </Typography>
            </Grid>
            <Grid item xs={2} sx={{ color: 'gray' }}>
              Booking Date
            </Grid>
            <Grid item xs={4}>
              <Typography
                variant="body1"
                sx={{
                  color: '#FFFFFF',
                }}
              >
                {formatDate(booking?.date)}
              </Typography>
            </Grid>

            <Grid item xs={2} sx={{ color: 'gray' }}>
              Booking Slot
            </Grid>
            <Grid item xs={4}>
              <Typography
                variant="body1"
                sx={{
                  color: '#FFFFFF',
                }}
              >
                {capitalizeWords((booking?.slot ?? '').replace('_', ' ')) ||
                  'N/A'}
              </Typography>
            </Grid>
          </Grid>
        </CardContent>
      </Box>
      <Divider sx={{ borderColor: '#444' }} />
    </>
  );
};
